import React from 'react';
import validate from 'validate.js';
import validation from '../../validation/login';

import { Button } from "react-materialize";

import l10n from '../../l10n/localization';

import * as actions from "../../actions/login";
import MiniLoader from "../common/MiniLoader";
import CWForm from "./CWForm";

class LoginForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            email: undefined,
            password: undefined,
        }
    }

    getSchema() {
        return {
            type: "object",
            properties: {
                email: {
                    type: "string",
                    title: l10n.login.fieldEmail,
                },
                password: {
                    type: "string",
                    title: l10n.login.fieldPassword,
                }
            }
        }
    }

    getUiSchema() {
        return {
            email: {
                "ui:widget": "email",
            },
            password: {
                "ui:widget": "password",
            },
        }
    }


    handleLogin({formData}) {
        this.setState({...formData}, () => {
            this.props.dispatch(actions.submitUser(formData.email, formData.password));
        });
    }

    validate(formData, errors) {
        let validationErrors = validate(formData, validation, {fullMessages: false});

        if (validationErrors !== undefined) {
            for (let key in validationErrors) {
                if (errors[key] !== undefined) {
                    for (let i = 0; i < validationErrors[key].length; i++) {
                        errors[key].addError(validationErrors[key][i]);
                    }
                }
            }
        }
        return errors;
    }

    render() {
        return (
            <div>
                <h1 className="small">{l10n.login.formTitle}</h1>
                <CWForm schema={this.getSchema()}
                      formData={this.state}
                      uiSchema={this.getUiSchema()}
                      showErrorList={false}
                      validate={this.validate.bind(this)}
                      onSubmit={this.handleLogin.bind(this)} >
                    <div>
                        <Button className="pull-left" type="submit" disabled={this.props.connecting} > {this.props.connecting && <MiniLoader className="inline"/>} {l10n.login.buttonLogin}</Button>
                    </div>
                </CWForm>
            </div>
        )
    }
}

export default LoginForm;



// WEBPACK FOOTER //
// ./src/components/forms/LoginForm.js